<template>
  <section v-if="details.length" class="product-detail-items">
    <h2 class="more-details-title">{{ $store.getters.t('moreDetailsTitle') }}</h2>
    <div class="detail-carousel">
      <div
        class="detail-carousel__image image-frame"
        @touchstart.passive="handleTouchStart"
        @touchend.passive="handleTouchEnd"
      >
        <img :src="currentDetail.imageUrl" :alt="currentDetail.title || $store.getters.t('productDetail')">
        <button v-if="details.length > 1" type="button" class="detail-carousel__arrow detail-carousel__arrow--left" aria-label="Previous detail" @click="previous">
          <span></span>
        </button>
        <button v-if="details.length > 1" type="button" class="detail-carousel__arrow detail-carousel__arrow--right" aria-label="Next detail" @click="next">
          <span></span>
        </button>
      </div>
      <div v-if="details.length > 1" class="detail-carousel__dots">
        <button v-for="(detail, index) in details" :key="detail.id || index" type="button" :class="{ active: index === activeIndex }" :aria-label="`Go to detail ${index + 1}`" @click="goTo(index)"></button>
      </div>
      <div class="detail-item__copy">
        <h3>{{ currentDetail.title }}</h3>
        <p>{{ currentDetail.content }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductDetails',
  props: { details: { type: Array, default: () => [] } },
  data () { return { activeIndex: 0, touchStartX: 0, touchStartY: 0 } },
  computed: {
    currentDetail () { return this.details[this.activeIndex] || {} }
  },
  watch: {
    details () { this.activeIndex = 0 }
  },
  methods: {
    previous () { this.activeIndex = (this.activeIndex - 1 + this.details.length) % this.details.length },
    next () { this.activeIndex = (this.activeIndex + 1) % this.details.length },
    goTo (index) { this.activeIndex = index },
    // 手机端：左右滑动切换详情图（箭头只在 PC 端显示）
    handleTouchStart (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
    },
    handleTouchEnd (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch || !this.touchStartX) return
      const dx = touch.clientX - this.touchStartX
      const dy = touch.clientY - this.touchStartY
      this.touchStartX = 0
      if (this.details.length < 2) return
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return
      if (dx < 0) this.next()
      else this.previous()
    }
  }
}
</script>
